export default __webpack_public_path__ + "static/media/Sunflower-Cupcake.79725c83.jpg";